import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function RouteDropdownItem({ to, className, ...props }) {
	return <Link to={to} className={`dropdown-item ${className}`} {...props} />;
}

RouteDropdownItem.defaultProps = {
	className: ''
};

RouteDropdownItem.propTypes = {
	/**
	 * url path to link to
	 */
	to: PropTypes.string.isRequired,

	/**
	 * additional classes
	 */
	className: PropTypes.string,

	/**
	 * visible content of the link
	 */
	children: PropTypes.node.isRequired
};
